import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * WHY: Flexible info card using content projection for maximum reusability
 * SOLID: Open/Closed principle - extensible through content projection, not modification
 */
@Component({
  selector: 'info-card',
  templateUrl: './info-card.component.html',
  imports: [CommonModule],
  host: {
    '[class.flex-row-reverse]': 'reversed()',
    'class': 'block'
  }
})
export class InfoCardComponent {
  readonly reversed = input<boolean>(false);
}